import styled, { css } from "styled-components"
import { darken, mix } from "polished"

export const StyledDiv = styled.div`
  font-family: ${(props) => props.theme.fonts.body.family}, sans-serif;

  .react-select__control {
    border-width: 2px;
    border-radius: 8px;
    border-color: transparent;
    color: #000;
    min-height: unset;
    box-shadow: none;
    background: #fff;
    padding: 4px 10px 4px 2px;
  }

  .react-select__single-value,
  .react-select__multi-value__label {
    color: #333;
    font-size: 1rem;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__dropdown-indicator {
    color: #000;
    padding-right: 5px;
  }

  .react-select__menu {
    z-index: 10;
  }

  .react-select__option {
    font-size: 1rem;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 12px 16px;
    outline-offset: 0;
  }

  .react-select__option:hover {
    background: #f2f2f2;
    color: #000;
  }

  .react-select__placeholder {
    color: #000;
  }

  ${({ theme }) => css`
    .react-select__control.react-select__control--is-invalid {
      border-color: ${darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger)};
      background-color: ${mix(0.95, "#fff", theme.colors.danger)};
      color: ${darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger)};
    }
    .react-select__single-value.react-select__single-value--is-invalid {
      color: ${darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger)};
    }
  `}

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      .react-select__control {
        padding: 5px 10px 5px 16px;
        border: 1px solid #e6e6e6;
      }
      .react-select__value-container {
        padding: 0 10px 0 0;
      }
    `}
`
